var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM8 14.4C4.472 14.4 1.6 11.528 1.6 8C1.6 4.472 4.472 1.6 8 1.6C11.528 1.6 14.4 4.472 14.4 8C14.4 11.528 11.528 14.4 8 14.4Z",
    fill: "#64C1B4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.89737,
    y: 9.4723,
    width: 8.6,
    height: 2.2,
    rx: 1.1,
    transform: "rotate(-35.8705 3.89737 9.4723)",
    stroke: "#255986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54192 10.3637C4.18594 9.87139 4.29645 9.18373 4.78875 8.82775L6.97667 7.24567L8.26577 9.02843L6.07784 10.6105C5.58555 10.9665 4.89789 10.856 4.54192 10.3637Z",
    fill: "#255986",
    stroke: "#255986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaken);
export default __webpack_public_path__ + "static/media/taken.5e3069c4251a8a66dd551a1a5b4b0490.svg";
export { ForwardRef as ReactComponent };